import React from 'react';
import Icon from '../common/Icon'; // Corrected import path

const WelcomeGiftModal = ({ isOpen, onClose, onStartStory, userHasSeenPreview }) => {
  if (!isOpen) return null;

  // Check if device is mobile
  const isMobile = window.innerWidth < 1024;

  return (
    <div className="fixed inset-0 bg-black/60 z-50 p-4">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl p-6 text-center w-full max-w-sm max-h-[90vh] overflow-y-auto">
        <span className="text-6xl mb-4"><Icon name="gift" /></span> {/* Replaced hardcoded emoji with Icon component */}
        {userHasSeenPreview ? (
          <>
            <h2 className="text-2xl font-extrabold mb-2">Welcome to the Family!</h2>
            <p className="text-gray-600 mb-6">We're so glad you enjoyed the story! Your full 12-unit learning path is now unlocked.</p>
            <button onClick={onClose} className="w-full bg-blue-500 text-white font-bold py-3 rounded-xl">
              Let's Go!
            </button>
          </>
        ) : (
          <>
            <h2 className="text-2xl font-extrabold mb-2">Thank You for Subscribing!</h2>
            <p className="text-gray-600 mb-6">As a welcome gift, we've unlocked your first Interactive Storybook. Would you like to read it now?</p>
            <button onClick={onStartStory} className="w-full bg-green-500 text-white font-bold py-3 rounded-xl mb-3">
              Start Story Now
            </button>
            <button onClick={onClose} className="w-full text-gray-600 font-bold py-3 px-4 min-h-[44px]">
              I'll Find It Later
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default WelcomeGiftModal;
